export { AssignedLabelsTabContent } from './AssignedLabels/AssignedLabelsTabContent';
